<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>
<style>
  @import url("assets/base.css");
  .margin30px {
    margin: 30px;
  }

  .button1 {
    height: 40px;
    border-radius: 2px;
    font-size: 14px;
    background: #FFFFFF;
    color: #19409E;
    margin: 0 10px;
  }

  .button2 {
    background: #19409E;
    color: #FFFFFF;

  }
</style>

<style lang="scss">
@import "./styles/education-theme.scss";
</style>
